import type { ColumnDef } from '@tanstack/react-table';
import type React from 'react';
import type { AgencyContact } from '~/common/types';
import { AUTO_COL_WIDTH } from '~/components2/Table';
import store from '../../store';
import { subGeometryDisplayName } from '../subGeometries/helpers';

export const statusMap: { [key: string]: React.ReactNode } = {
  active: 'Active',
  archived: <div className="uppercase text-red-500">Archived</div>,
};

export const columns: ColumnDef<AgencyContact>[] = [
  {
    id: 'email',
    header: 'Email',
    accessorKey: 'email',
  },
  {
    id: 'firstName',
    header: 'First Name',
    accessorKey: 'firstName',
  },
  {
    id: 'lastName',
    header: 'Last Name',
    accessorKey: 'lastName',
  },
  {
    id: 'title',
    header: 'Title',
    accessorKey: 'title',
  },
  {
    id: 'subRegion',
    header: 'Sub Region',
    // Reads the proxy directly (same pattern as isDefaultContact below). subGeometries
    // is loaded alongside contacts in store.fetchData, so the name is resolvable by the
    // time rows render. Empty string for unscoped contacts.
    accessorFn: (c) => {
      if (!c.agencySubGeometryId) return '';
      return subGeometryDisplayName(store.subGeometries.find((sg) => sg.id === c.agencySubGeometryId)?.name);
    },
  },
  {
    id: 'isDefaultContact',
    header: 'Default Contact',
    accessorFn: (c) => {
      if (store.agency?.defaultContact === c.contactId) {
        return '✅';
      }

      return null;
    },
  },
  {
    id: 'notes',
    header: 'Notes',
    accessorKey: 'notes',
    size: AUTO_COL_WIDTH,
  },
  {
    id: 'status',
    header: 'Status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const v = getValue<string>();
      if (statusMap[v]) {
        return statusMap[v];
      }

      return null;
    },
  },
];
